import { useMemo, useState } from 'react';
import { useGetMlComputeOrdersQuery } from 'store/apis/walletApi';
import { IN_PROGRESS_STATUSES } from 'components/TeamOverview/components/AiComputeTransactionsCard/constants';
import { getAnalysisType } from 'components/AITools/utilities/common';

export const useIsMLAnalyzeInProgress = (slides, modelId) => {
  const { data: computeOrders = [] } = useGetMlComputeOrdersQuery();

  // use this state to render "Analyzing" button immediately after clicking submitting analysis
  const [locallyStarted, setAnalysisLocallyStarted] = useState(false);

  const isBackendInProgress = useMemo(() => {
    const analysisType = getAnalysisType(modelId);

    const logs = computeOrders
      .filter((computeOrder) => computeOrder.processing_type === analysisType)
      .flatMap((computeOrder) => computeOrder.slide_ml_processing_logs)
      .sort((a, b) => Date.parse(b.created) - Date.parse(a.created));

    return slides
      .map((slide) => logs.find((log) => log.slide.uuid === slide.uuid))
      .every((log) => log && IN_PROGRESS_STATUSES.includes(log.state));
  }, [computeOrders, slides, modelId]);

  return {
    isAnalyzeInProgress: locallyStarted || isBackendInProgress,
    setAnalysisLocallyStarted,
  };
};
